import { ReduxUtils } from '../../../dependencies';
import types from '../../actionTypes';

const actionTypes = {
    REQUEST: types.FETCH_SUPPLIER_REQUEST,
    SUCCESS: types.FETCH_SUPPLIER_SUCCESS,
    FAILURE: types.FETCH_SUPPLIER_FAILURE,
    CANCEL: types.FETCH_SUPPLIER_CANCEL,
};

const basicReducer = ReduxUtils.basicApiReducer({
    actionTypes,
});

export default ReduxUtils.containerReducer({
    childReducer: basicReducer,
    actionTypes: Object.values(actionTypes),
    selectors: {
        itemId: action => action.meta.id,
    },
});
